import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DEFAULT_LANG, LANGUAGES, getTranslations } from "../lib/i18n";

const LanguageContext = createContext(null);

const STORAGE_KEY = "chemara_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(DEFAULT_LANG);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && LANGUAGES.some((l) => l.code === stored)) {
        setLangState(stored);
      }
    } catch {
      /* localStorage unavailable */
    }
  }, []);

  const setLang = (code) => {
    setLangState(code);
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch {
      /* ignore */
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = code;
    }
  };

  const value = useMemo(() => {
    const t = getTranslations(lang);
    return { lang, setLang, t, languages: LANGUAGES };
  }, [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
